var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "550mm",
    height: 2357.514,
    viewBox: "0 0 550 623.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m2771.954-181.668-42.584 477.056-191.42 53.067-190.892-52.993-42.54-477.13z",
    style: {
      fill: "#e44d26",
      strokeWidth: 1.83229458
    },
    transform: "translate(-2711.565 213.756) scale(1.17663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2538.236 307.892 154.677-42.881 36.39-407.668h-191.067z",
    style: {
      fill: "#f16529",
      strokeWidth: 1.83229458
    },
    transform: "translate(-2711.565 213.756) scale(1.17663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2455.453-25.619h82.783v-58.518h-146.735l1.4 15.7 14.383 161.26h130.952V34.305h-77.434zm13.189 147.702h-58.743l8.197 91.882 119.87 33.274.27-.073v-60.883l-.256.067-65.171-17.597z",
    style: {
      fill: "#ebebeb",
      strokeWidth: 1.83229458
    },
    transform: "translate(-2711.565 213.756) scale(1.17663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2538.035 92.823h72.058l-6.794 75.893-65.266 17.616v60.88l119.965-33.247.88-9.887 13.753-154.06 1.428-15.713h-136.024zm0-118.585v.143h141.348l1.173-13.152 2.668-29.667 1.398-15.699h-146.587v58.377z",
    style: {
      fill: "#fff",
      strokeWidth: 1.83229458
    },
    transform: "translate(-2711.565 213.756) scale(1.17663)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.a02175b70776eb8b3daa551e04667bba.svg";
export { ForwardRef as ReactComponent };